import { FiArrowRight } from "react-icons/fi"; // Example icon from react-icons
import Button from '../components/Button';

import Spline from '@splinetool/react-spline';
import { Link } from "react-router-dom";
// import Spline from '@splinetool/react-spline/next';



const LeftSection = () => (
    <section className="dark:bg-black dark:text-white h-[60vh] flex items-center justify-center px-10 xl:px-0">
        {/* <div className="w-full">
            <h1 className="text-5xl font-bold leading-tight mb-2">
                Making your website <br /> run seamlessly. 
            </h1>
            <h2 className="text-4xl font-bold flex items-center mb-6">
                This is a sample
                <FiArrowRight className="ml-2" />
            </h2>
            <p className="dark:text-gray-300 text-zinc-600 mb-6">
                With all our in-house expertise and experience, our brand creation services gets our global clients noticed for all the right reasons.
            </p>
            <Button>
                Tell us about your project
            </Button>
        </div> */}

        <div className='h-fit space-y-5  xl:ml-10'>
            <div className=" text-center xl:text-left">
                <h3 className='text-sm text-zinc-500 font-semibold uppercase'>Technology Services</h3>
                <h1 className="xl:text-6xl text-4xl font-bold mt-2 ">
                    Unlocking the true power of code. <br />

                </h1>
            </div>
            <div className="text-center xl:text-left">
                <p className="text-lg dark:text-zinc-200">
                    With all our in-house expertise and experience, our brand creation services gets our global clients noticed for all the right reasons.
                </p>
            </div>
            <Link to={"/contact"} className="w-full mx-auto flex xl:inline justify-center items-center">
                <Button>Contact us</Button>
            </Link>

        </div>


    </section>
);




const WebSec1 = () => {
    return (
        <div className='min-h-screen w-full flex flex-col-reverse xl:flex-row items-center justify-between xl:px-35 relative z-10 pointer-events-auto'>
            <LeftSection />

            <div className=" xl:w-fit w-full">
                <div className="xl:h-[90vh] xl:w-[40vw] h-screen w-full relative hidden xl:block">
                    <Spline
                        className="h-full w-full scale-80"
                        scene="https://prod.spline.design/qrOLxZo-D3fxEiYw/scene.splinecode"
                    />
                    <div className="absolute bottom-[11.5%] right-[12%] h-[40px] w-[120px] dark:bg-black bg-white"></div>
                </div>

                <div className=" h-screen w-full relative xl:hidden">
                    <img src="/new-final-data/web/web-landing.png" className='h-full w-full object-cover' alt="" />
                </div>
            </div>
        </div>
    )
}

export default WebSec1